import styled from 'styled-components';
import color from 'tinycolor2';

export const Wrapper = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 55px;
  overflow: auto;
  color: ${(props) => props.theme['color.text.body']};
  background: ${(props) => props.theme['color.background']};

  @media(max-width: ${(props) => props.theme['media.mobile']}px) {
    padding: 10px;
  }
`;

export const Form = styled.form`
  max-width: 340px;
  width: 100%;

  h2 {
    font-weight: 600;
    margin-bottom: 30px;
  }
`;

export const ActionsWrapper = styled.div`
  margin-top: 30px;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr min-content;
  width: 100%;
  align-items: center;
  font-size: 14px;

  @media(max-width: 340px) {
    grid-template-columns: 100%;
    grid-gap: 30px;
  }
`;

export const ErrorMessage = styled.div`
  transition: all 0.3s ease;
  width: 100%;
  display: flex;
  margin-top: ${(props) => props.visible ? '25px' : '0'};
  background: ${(props) => color(props.theme['color.redLight']).setAlpha(0.2).toString()};
  color: ${(props) => props.theme['color.red.text']};
  border-radius: 4px;
  text-shadow: none;
  padding: ${(props) => props.visible ? '8px 0' : '0'};
  font-size: 14px;
  justify-content: center;
  height: ${(props) => props.visible ? '39px' : '0px'};
  overflow: hidden;
`;

export const InputWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-gap: 20px;
`;

export const IesWrapper = styled.div`
  position: relative;
  margin-top: 8px;
  max-width: 340px;
  width: 100%;
`;

export const IesAction = styled.div`
  margin-top: 8px;
`;
